const AppointmentState={
    upcomingApp:[],
    previousApp:[],
    isLoaded:false
}

export default AppointmentState;